import { useEffect, useState } from "react";
import PlayerCard from "../Components/Player/PlayerCard";
import TeamProfileHeader from '../Components/Team/TeamProfileHeader';
import MobTeamProfileHeader from "../Components/MobileComponents/MobTeamProfileHeader";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../apiConfig";
import { motion, AnimatePresence } from 'framer-motion';
import FixtureCard from "../Components/UIcomponents/FixtureCard";
import Result from "../Components/UIcomponents/Result";

function TeamProfile() {
    const { team_id } = useParams();
    const [teamProfile, setTeamProfile] = useState(null);
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = windowWidth <= 1024;

    useEffect(() => {
        setLoading(true);
        // Team Profile
        axios.get(`${API_BASE_URL}/TeamProfile/${team_id}`).then((res) => {
            setTeamProfile(res.data);
        });

        // Players
        axios.get(`${API_BASE_URL}/teamPlayer/${team_id}`).then((res) => {
            setPlayers(res.data || []);
            setLoading(false);
        });
    }, [team_id]);

    const styles = {
        container: {
            maxWidth: '1100px',
            margin: '0 auto',
            padding: isMobile ? '32px 16px' : '48px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: isMobile ? '32px' : '48px',
            minHeight: '600px',
            boxSizing: 'border-box',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
            gap: isMobile ? '16px' : '20px',
            width: '100%',
        }
    };

    if (!teamProfile && !loading) return <div style={{textAlign: 'center', padding: '100px'}}>Team profile not found.</div>;

    return (
        <div style={{ background: '#FFFFFF', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div style={{ width: '100%', maxWidth: '1280px', padding: isMobile ? '16px' : '32px 24px', boxSizing: 'border-box' }}>
                {teamProfile && (
                    isMobile ? <MobTeamProfileHeader data={teamProfile} /> : <TeamProfileHeader data={teamProfile} />
                )}
            </div>
            
            <div style={styles.container}>
                {loading ? (
                    <div className="loader" style={{ margin: '50px auto' }}></div>
                ) : (
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ width: '100%' }}
                    >
                        <div style={styles.grid}>
                            {players.map((p, i) => (
                                <PlayerCard key={i} data={p} teamId={team_id} />
                            ))}
                        </div>
                    </motion.div>
                )}
            </div>
        </div>
    );
}

export default TeamProfile;